<div *ngIf="!isLoading">
    <div
        style=" position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>

<div class="container">
    <div *ngIf="data_report" [ngStyle]="isLoading ? { visibility: 'visible' } : { visibility: 'hidden' }">
        <div class="row justify-content-center" style="padding: 5% 0">
            <h1 class="lifedi-color" style="font-weight: bold">
                {{ data_report.reportname }}
            </h1>
        </div>
        <h2 style="text-decoration: underline" style="font-weight: bold; text-decoration: underline">
            {{ data_report.measure_name }}
        </h2>
        <h3>
            {{ data_report.report_description }}
        </h3>

        <div class="d-flex">
            <h4 class="box-header text-center my-3">
                ผู้ทำแบบทดสอบ
            </h4>
        </div>

        <div class="justify-content-center" style="padding: 5% 0">
            <div *ngFor="let data of data_report.data">
                <div style="position: absolute; left: -5000px; width: 40%;">
                    <canvas id="StandardChartpdf{{ data.id }}"></canvas>
                </div>
                <div style="margin: 0 auto; width: 50%">
                    <canvas id="StandardChart{{ data.id }}" #allcanvas></canvas>
                </div>
                <div style="padding: 2% 0">
                    <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
                        {{ data.psy_name }}
                    </h2>
                    <h4 [innerText]="data.psy_description"></h4>
                    <h2 style="font-weight: bold">
                        คะแนนต่ำสุด : {{ data.min }} คะแนนสูงสุด : {{ data.max }}
                    </h2>
                    <h2 class="lifedi-color" style="font-weight: bold">
                        ท่านได้ {{ data.value | number: '1.2-2' }} คะแนน
                    </h2>
                    <h4 style="padding-bottom: 3%" [innerText]="data.range_description"></h4>
                    <hr style="width: 70%; text-align: center" />
                </div>
            </div>
        </div>

        <hr class="my-2 underline-blue">

        <div class="d-flex">
            <h4 class="box-header text-center my-3">
                ผู้มีส่วนร่วมในแบบทดสอบนี้
            </h4>
        </div>

        <div class="informant-box my-3">
            <h4 class="text-header">
                รายงานผลของผู้มีส่วนร่วมนี้เป็นของ
            </h4>
            <div class="d-flex">
                <h4 *ngFor="let p of data_report.parances; let i = index" class="text-participant">
                    <span *ngIf="i !== 0">,</span>
                    {{ p.EMAIL }} ({{ p.TAG }})
                </h4>
            </div>
        </div>

        <!-- informant -->
        <div class="justify-content-center" style="padding: 5% 0">
            <div *ngFor="let dataInf of data_report.data2">
                <div style="position: absolute; left: -5000px; width: 40%;">
                    <canvas id="StandardChartpdfInformant{{ dataInf.id }}"></canvas>
                </div>
                <div style="margin: 0 auto; width: 50%">
                    <canvas id="StandardChartInformant{{ dataInf.id }}" #allcanvas></canvas>
                </div>
                <div style="padding: 2% 0">
                    <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
                        {{ dataInf.psy_name }}
                    </h2>
                    <h4 [innerText]="dataInf.psy_description"></h4>
                    <h2 style="font-weight: bold">
                        คะแนนต่ำสุด : {{ dataInf.min }} คะแนนสูงสุด : {{ dataInf.max }}
                    </h2>
                    <h2 class="lifedi-color" style="font-weight: bold">
                        ท่านได้ {{ dataInf.value | number: '1.2-2' }} คะแนน
                    </h2>
                    <h4 style="padding-bottom: 3%" [innerText]="dataInf.range_description"></h4>
                    <hr style="width: 70%; text-align: center" />
                </div>
            </div>
        </div>

        <div class="justify-content-center" style="padding: 5% 0">
            <div style="text-align: center; padding: 5% 0" *ngIf="data_report">
                <lifedi-btn lable="ดาวน์โหลด" (click)="filepdf('download')" customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px;
                padding: 0 25px;">
                </lifedi-btn>
            </div>
        </div>
    </div>
</div>